import {HttpClient, POST, expectEither} from '@raison/network-facade';
import {NonNegativeDoubleString} from '@raison/types';
import {Transaction} from './ExchangeFiat';

export const exchangeEurUsd = async (http: HttpClient, amount: NonNegativeDoubleString) => {
    return http('v1/exchange/sell', POST({value: amount, base: 'EUR', quote: 'USD'})).then(
        ...expectEither({
            200: Transaction,
            201: Transaction,
            400: null,
        })
    );
};

export const exchangeUsdEur = async (http: HttpClient, amount: NonNegativeDoubleString) => {
    return http('v1/exchange/buy', POST({value: amount, base: 'EUR', quote: 'USD'})).then(
        ...expectEither({
            200: Transaction,
            201: Transaction,
            400: null,
        })
    );
};
